import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getVahan01Details,
  clearVahan01Details,
} from 'src/redux/Actions/VehicleTracking';
import Spinner from 'react-bootstrap/Spinner';
import TruckXs from 'src/Images/icons/truck/truck-xs.png';
import TruckSm from 'src/Images/icons/truck/truck-sm.png';
import TruckMd from 'src/Images/icons/truck/truck-md.png';
import TruckLg from 'src/Images/icons/truck/truck-lg.png';
import TruckXl from 'src/Images/icons/truck/truck-xl.png';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as ActiveIcon } from 'src/Images/icons/common/activeIcon.svg';
import { ReactComponent as NicdcIcon } from 'src/Images/icons/common/nicdcIcon.svg';
import NldsIcon from 'src/Images/icons/common/nldsIcon.png';
import { ReactComponent as ModelIcon } from 'src/Images/icons/common/modelIcon1.svg';
import { ReactComponent as RegistrationIcon } from 'src/Images/icons/common/registrationNumberIcon1.svg';
import { ReactComponent as VehicleWeigthIcon } from 'src/Images/icons/common/grossWeightIcon1.svg';
import { ReactComponent as VehicleDetailsEmptyStateIcon1 } from 'src/Images/icons/EmptyStates/vahanEmptyState.svg';
import { ReactComponent as RegulatoryIcon } from 'src/Images/icons/common/regulatoryIcon1.svg';
import { ReactComponent as VehicleRegistrationDetails } from 'src/Images/icons/common/vehicleRegistrationIcon1.svg';
import { ReactComponent as VehicleSpecifications } from 'src/Images/icons/common/vehicleSpecificationIcon1.svg';
import { ReactComponent as RegistrationValidUpto } from 'src/Images/icons/common/registrationValidUptoIcon1.svg';

export default function VehicleDetails({ vehicleNumber, onClose }) {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const vahan01DetailsData = vehicleTrackingDataReducer?.vahan01Details;
  const [isVehicleDetailsLoading, setIsVehicleDetailsLoading] = useState(true);

  useEffect(() => {
    if (vehicleNumber) {
      setIsVehicleDetailsLoading(true);
      dispatch(clearVahan01Details());
      dispatch(getVahan01Details(tenantOrganisationId, vehicleNumber)).finally(
        () => {
          setIsVehicleDetailsLoading(false);
        },
      );
    }
  }, [dispatch, tenantOrganisationId, vehicleNumber]);

  if (isVehicleDetailsLoading) {
    return (
      <div className="div-flex-column div-align-center justify-content-center vehicle-details-container right-drawer-component-medium">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (vahan01DetailsData?.error) {
    return (
      <div className="page-layout">
        <div className=" div-flex-row div-align-center div-space-between padding-top-10 padding-bottom-10 horizontal-padding-10 border-bottom">
          <div className="text-lg text-semi-bold ">Vehicle Details</div>
          <button
            className="icon-btn-none"
            onClick={onClose}
            aria-label="Close"
          >
            <Close className="icon-size-sm" />
          </button>
        </div>
        <div className="div-flex-column align-item-center justify-content-center vehicle-details-error-container right-drawer-component-medium">
          <div className="div-flex-column div-align-center justify-content-center">
            <VehicleDetailsEmptyStateIcon1 className="vehicle-details-empty-state-icon" />
          </div>
          <div className="div-align-center div-flex-column rg-10">
            <div className="text-md text-grey text-center px-5">
              {vahan01DetailsData?.message}
            </div>
            <div>
              <button
                className={`common-btn theme-background-${themeColor}`}
                onClick={onClose}
              >
                <div className="div-align-center text-sm">Go back</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const vehicleDetailComponents = [
    {
      id: 1,
      title: 'Regulatory Details',
      component: (
        <div>
          <div className="div-flex-column">
            <Row className="g-3">
              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">PUCC Number</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.regulatoryDetails?.pucc_number || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">PUCC Valid Upto</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.regulatoryDetails?.pucc_valid_upto ||
                    'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">
                  National Permit Issued By
                </div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.regulatoryDetails
                    ?.national_permit_issued_by || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">
                  Non-use Declaration
                </div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.regulatoryDetails?.non_use_declaration ||
                    'N/A'}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      ),
    },
    {
      id: 2,
      title: 'Vehicle Specifications',
      component: (
        <div>
          <div className="div-flex-column">
            <Row className="g-3">
              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Vehicle Category</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications
                    ?.vehicle_category || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Class Description</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications
                    ?.vehicle_class_description || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Type Code</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications
                    ?.vehicle_type_code || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Class Code</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications
                    ?.vehicle_class_code || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Body Type</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications?.body_type ||
                    'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Fuel Type</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications?.fuel_type ||
                    'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Model</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications?.model || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Color</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications?.color || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">
                  Gross Vehicle Weight
                </div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleSpecifications
                    ?.gross_vehicle_weight || 'N/A'}{' '}
                  kg
                </div>
              </Col>
            </Row>
          </div>
        </div>
      ),
    },
    {
      id: 3,
      title: 'Vehicle Registration Details',
      component: (
        <div>
          <div className="div-flex-column">
            <Row className="g-3">
              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Status</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleRegistrationDetails?.status ||
                    'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Vehicle Number</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleRegistrationDetails
                    ?.vehicle_number || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">
                  Registration Number
                </div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleRegistrationDetails
                    ?.registration_number || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Registration Date</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleRegistrationDetails
                    ?.registration_date || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">
                  Registration Valid Upto
                </div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleRegistrationDetails
                    ?.registration_valid_upto || 'N/A'}
                </div>
              </Col>

              <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
                <div className="text-sm text-semi-bold">Purchase Date</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleRegistrationDetails
                    ?.purchase_date || 'N/A'}
                </div>
              </Col>

              <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                <div className="text-sm text-semi-bold">Registered At</div>
                <div className="text-sm text-grey text-bold-500">
                  {vahan01DetailsData?.vehicleRegistrationDetails
                    ?.registered_at || 'N/A'}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      ),
    },
  ];

  const vehicleType = vahan01DetailsData?.vehicleSpecifications?.vehicle_type;

  return (
    <div
      className={`theme-scrollable-container-${themeColor} div-flex-column rg-10 right-drawer-component-medium `}
    >
      <div className=" div-flex-column rg-20 vertical-padding-10 horizontal-padding-10">
        <div className="vehicle-detail-card-margin">
          <div className="div-flex-column rg-20 padding-bottom-10">
            <Row className="g-0 p-0">
              <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                <div className="div-flex-column rg-20">
                  <div className="text-sm text-semi-bold text-nowrap">
                    <button className="icon-btn-none">
                      <span className="text-xl text-bold">
                        {vehicleNumber || 'N/A'}
                      </span>
                    </button>
                  </div>
                  <div className="vehicle-pill-scroll">
                    <div className="vehicle-tracking-pill-green">
                      <ActiveIcon className="icon-size-sm" />
                      <span className="text-sm ps-1">
                        {vahan01DetailsData?.vehicleRegistrationDetails
                          ?.status || 'N/A'}
                      </span>
                    </div>

                    <div className="vehicle-tracking-pill-nicdc">
                      <NicdcIcon className="icon-size-md" />
                      <span className="ps-1 text-sm">NICDC VERIFIED</span>
                    </div>

                    <div className="vehicle-tracking-pill-nlds">
                      <img
                        src={NldsIcon}
                        height={18}
                        width={26}
                        aria-label="nlds-image"
                      />
                      <span className="ps-1 text-sm">NLDS VERIFIED </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                <div className="div-flex-row w-100 div-flex-end cg-20">
                  <div className="padding-top-10">
                    {vehicleType === '1' ? (
                      <img
                        src={TruckXs}
                        alt="truck"
                        className="vehicle-detail-icon-size-truck-revert"
                      />
                    ) : vehicleType === '2' ? (
                      <img
                        src={TruckSm}
                        alt="truck"
                        className="vehicle-detail-icon-size-truck-revert"
                      />
                    ) : vehicleType === '3' ? (
                      <img
                        src={TruckMd}
                        alt="truck"
                        className="vehicle-detail-icon-size-truck-revert"
                      />
                    ) : vehicleType === '4' ? (
                      <img
                        src={TruckLg}
                        alt="truck"
                        className="vehicle-detail-icon-size-truck-revert"
                      />
                    ) : (
                      <img
                        src={TruckXl}
                        alt="truck"
                        className="vehicle-detail-icon-size-truck-revert"
                      />
                    )}
                  </div>

                  <button
                    className="icon-btn-none"
                    onClick={onClose}
                    aria-label="Close"
                  >
                    <Close className="icon-size-sm" />
                  </button>
                </div>
              </Col>
            </Row>
            <Row className="g-2">
              <Col xxl={3} xl={3} lg={3} md={3} sm={4} xs={6}>
                <div className="div-flex-row cg-10 div-flex-center">
                  <div className="model-info-card">
                    <VehicleWeigthIcon className="icon-size-xl" />
                  </div>
                  <div className="div-flex-column">
                    <div className="text-nowrap div-flex-row div-align-center cg-5">
                      <span className="text-bold-500 text-sm text-grey">
                        Gross Vehicle Weight
                      </span>
                    </div>
                    <div className="text-sm text-semi-bold text-ellipsis">
                      {vahan01DetailsData?.vehicleSpecifications
                        ?.gross_vehicle_weight || 'N/A'}{' '}
                      kg
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={3} xl={3} lg={3} md={3} sm={4} xs={6}>
                <div className="div-flex-row cg-10 div-flex-center">
                  <div className="model-info-card">
                    <ModelIcon className="icon-size-xl" />
                  </div>
                  <div className="div-flex-column">
                    <div className="text-nowrap div-flex-row div-align-center cg-5">
                      <span className="text-bold-500 text-sm text-grey">
                        Model
                      </span>
                    </div>
                    <div className="text-sm text-semi-bold text-ellipsis">
                      <span className="text-ellipsis">
                        {vahan01DetailsData?.vehicleSpecifications?.model ||
                          'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={3} xl={3} lg={3} md={3} sm={4} xs={6}>
                <div className="div-flex-row cg-10 div-flex-center">
                  <div className="model-info-card">
                    <RegistrationIcon className="icon-size-xl" />
                  </div>
                  <div className="div-flex-column">
                    <div className="text-nowrap div-flex-row div-align-center cg-5">
                      <span className="text-bold-500 text-sm text-grey">
                        Registration Number
                      </span>
                    </div>
                    <div className="text-sm text-semi-bold text-ellipsis">
                      {vahan01DetailsData?.vehicleRegistrationDetails
                        ?.registration_number || 'N/A'}
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={3} xl={3} lg={3} md={3} sm={4} xs={6}>
                <div className="div-flex-row cg-10 div-flex-center">
                  <div className="model-info-card">
                    <RegistrationValidUpto className="icon-size-xl" />
                  </div>
                  <div className="div-flex-column">
                    <div className="text-nowrap div-flex-row div-align-center cg-5">
                      <span className="text-bold-500 text-sm text-grey">
                        Registration Valid Upto
                      </span>
                    </div>
                    <div className="text-sm text-semi-bold text-ellipsis">
                      {vahan01DetailsData?.vehicleRegistrationDetails
                        ?.registration_valid_upto || 'N/A'}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="padding-top-10 border-bottom" />
        </div>

        <div className="vehicle-details-timeline">
          <span className="timeline-spine" />
          {vehicleDetailComponents.map((item, index) => (
            <div key={item.id} className="timeline-item">
              <div className="timeline-left">
                <div className="timeline-circle">
                  {index === 0 && <RegulatoryIcon className="icon-size-md" />}
                  {index === 1 && (
                    <VehicleRegistrationDetails className="icon-size-md" />
                  )}
                  {index === 2 && (
                    <VehicleSpecifications className="icon-size-md" />
                  )}
                </div>
              </div>
              <div className="timeline-content">
                <div className="timeline-title">{item.title}</div>
                <div className="timeline-card">{item.component}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
